"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("@gin-betting/constants");
function isFetchFinished(fetchStatus) {
    return [constants_1.FetchStatus.LOADED, constants_1.FetchStatus.FAILED].includes(fetchStatus);
}
exports.default = isFetchFinished;
//# sourceMappingURL=isFetchFinished.js.map